/**
 * This file is really here to make our calls to window unload
 * a little more easy to understand.  If the calls to window.onunload
 * are scattered all over the place, then the calls remain a little
 * difficult to track down.  What this file, a bit of an odd duck, gives
 * us is the ability via typescript to trace those calls.
 */

const terminationEvent = (() => {
  return typeof window !== 'undefined' && 'onpagehide' in window
    ? 'pagehide'
    : 'unload';
})();

const addEventListener = (
  fn: any,
  options?: boolean | AddEventListenerOptions
) => {
  return window.addEventListener(terminationEvent, fn, options);
};

const removeEventListener = (
  fn: any,
  options?: boolean | EventListenerOptions
) => {
  return window.removeEventListener(terminationEvent, fn, options);
};

export { addEventListener, removeEventListener };
